<!-- your component HTML file -->
<div class="custom-dialog">
    <div class=row>
      <div class="col-md-10" style="text-align: center;">
        <h1 mat-dialog-title>{{data.title}}</h1>
      </div>
      <div class="col-md-2 cross-icon">
        <!-- <i class="pi pi-times" style="margin: 35% 0 0 25%;" (click)="onNoClick()"></i> -->
      </div>
    </div>
    <div mat-dialog-content style="padding-top: 0;text-align: center;" >
      <!-- <p>{{data.message}}</p> -->
      <!-- <p>{{data.caption}}</p> -->
      <p *ngIf="timeLeft!=0">You will logout in {{timeLeft}} seconds!</p>
      <p *ngIf="timeLeft==0">Your session timed out</p>
    </div>
    <div mat-dialog-actions align="end" style="padding-bottom: 0;padding-right: 0;">
      <button *ngIf="data.close_btn !== '' && timeLeft!=0" style="margin: 0 5% 5% 0;" class="btn btn-solid" mat-raised-button color="secondary" (click)="onNoClick()" >{{data.close_btn}}</button>
      <button class="btn btn-solid" mat-raised-button color="primary" style="margin: 0 5% 5% 0;" (click)="onSubmitClick()" cdkFocusInitial >{{data.submit_btn}}</button>
    </div>
  </div>
  